
class EnumArray extends Array {

    /**
     *
     * @param {string} key
     * @returns {string}
     */
    getLabelByKey(key) {
        const foundItem = this.getItemByKey(key);
        return foundItem?.label;
    }

    /**
     *
     * @param {string} key
     * @returns {object}
     */
    getItemByKey(key) {
        return this.find(item => item.key === key);
    }

}

export const SITUATIONS = new EnumArray(
    {
        key: 1,
        label: 'Ativo',
    },
    {
        key: 0,
        label: 'Inativo',
    },
);

export const GENDER = new EnumArray(
    {
        key: 'MASCULINO',
        label: 'Masculino',
    },
    {
        key: 'FEMININO',
        label: 'Feminino',
    },
    {
        key: 'OUTRO',
        label: 'Outro',
    },
);

export const PERSON_TYPE = new EnumArray(
    {
        key: 'FISICA',
        label: 'Física',
    },
    {
        key: 'JURIDICA',
        label: 'Jurídica',
    },
);

export const YES_NO = new EnumArray(
    {
        key: 1,
        label: 'Sim',
    },
    {
        key: 0,
        label: 'Não',
    },
);

export const FREQUENCY = new EnumArray(
    {
        key: 'SEMANAL',
        label: 'Semanal',
    },
    {
        key: 'QUINZENAL',
        label: 'Quinzenal',
    },
    {
        key: 'MENSAL',
        label: 'Mensal',
    },
);

export const DOCUMENT_TYPE = new EnumArray(
    {
        key: 'ADMISSAO',
        label: 'Admissão',
    },
    {
        key: 'DEMISSAO',
        label: 'Demissão',
    },
);

export const DISCOUNTS_AT_SOURCE = new EnumArray(
    {
        key: 'CONTRIBUICAO_SINDICAL',
        label: 'Contribuição sindical',
    },
    {
        key: 'PLANO_DE_SAUDE',
        label: 'Plano de saúde',
    },
    {
        key: 'PLANO_ODONTOLOGICO',
        label: 'Plano odontológico',
    },
    {
        key: 'IR',
        label: 'Imposto de renda',
    },
    {
        key: 'PLANO_DE_SAUDE_COPARTICIPATIVO',
        label: 'Plano de saúde corporativo',
    },
    {
        key: 'VALE_TRANSPORTE',
        label: 'Vale transporte',
    },
    {
        key: 'INSS',
        label: 'INSS',
    },
);

export const DAYS_OFF = new EnumArray(
    {
        key: 'DOMINGO',
        label: 'Domingo',
    },
    {
        key: 'SEGUNDA',
        label: 'Segunda',
    },
    {
        key: 'TERCA',
        label: 'Terça',
    },
    {
        key: 'QUARTA',
        label: 'Quarta',
    },
    {
        key: 'QUINTA',
        label: 'Quinta',
    },
    {
        key: 'SEXTA',
        label: 'Sexta',
    },
    {
        key: 'SABADO',
        label: 'Sábado',
    },
);

export const EXTRA_HOUR_TYPE = new EnumArray(
    {
        key: 'CREDITO',
        label: 'Crédito',
    },
    {
        key: 'DEBITO',
        label: 'Débito',
    },
);

export const ACCEPT_FILES = [
    'image/*', // qualquer imagem
    'video/*', // qualquer vídeo
    'audio/*', // qualquer aúdio
    'text/*', // qualquer texto
    'application/zip', // zip
    'application/pdf', // pdf
    'application/xml', // xml
    'application/vnd.ms-powerpoint', // ppt
    'application/vnd.openxmlformats-officedocument.presentationml.presentation', // pptx
    'application/vnd.ms-excel', // xls
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx
    'application/msword', // doc
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
    'application/vnd.oasis.opendocument.presentation', // odp
    'application/vnd.oasis.opendocument.graphics', // odg
    'application/vnd.oasis.opendocument.spreadsheet', // ods
    'application/vnd.oasis.opendocument.text', // odt
    'application/vnd.sun.xml.writer', // openoffice sxw
    'application/vnd.sun.xml.calc', // openoffice sxc
    'application/vnd.sun.xml.draw', // openoffice sxd
    'application/vnd.sun.xml.impress', // openoffice sxi
    'application/vnd.sun.xml.math', // openoffice sxm
];

export const PARTICIPATIONS_TYPE = new EnumArray(
    {
        key: 'INSTRUTOR',
        label: 'Instrutor',
    },
    {
        key: 'ALUNO',
        label: 'Aluno',
    },
);

export const OCCURRENCES = new EnumArray(
    {
        key: 'RELACIONAMENTO',
        label: 'Relacionamento',
    },
    {
        key: 'PERFORMANCE',
        label: 'Performance',
    },
    {
        key: 'COMPORTAMENTO',
        label: 'Comportamento',
    },
);

export const REPRESENTED_PARTY = new EnumArray(
    {
        key: 'POLO_ATIVO',
        label: 'Polo ativo',
    },
    {
        key: 'POLO_PASSIVO',
        label: 'Polo passivo',
    },
);

export const FILE_MAX_SIZE = 25 * 1024 * 1024; // 25 mega

export const PAYMENT_TYPE = new EnumArray(
    {
        key: 'PIX',
        label: 'PIX',
    },
    {
        key: 'CARTAO',
        label: 'Cartão',
    },
    {
        key: 'PIX_CARTAO',
        label: 'PIX e Cartão',
    },
);

export const PAYMENT_CICLE = new EnumArray(
    {
        key: 'MENSAL',
        label: 'Mensal',
    },
    {
        key: 'ANUAL',
        label: 'Anual',
    },
);

export const SUBSCRIPTION_STATUS = new EnumArray(
    {
        key: 'PENDENTE',
        label: 'Assinatura pendente',
    },
    {
        key: 'VENCIDA',
        label: 'Assinatura vencida',
    },
    {
        key: 'CANCELADA',
        label: 'Assinatura cancelada',
    },
    {
        key: 'SEM_ASSINATURA',
        label: 'Sem assinatura',
    },
);

export const SIGNATURE_STATUS = {
    PENDENTE: 'PENDENTE',
    CANCELADA: 'CANCELADA',
    SUBSTITUIDA: 'SUBSTITUIDA',
    VENCIDA: 'VENCIDA',
    VIGENTE: 'VIGENTE',
};

export const PAYMENT_LABELS = {
    MENSAL: 'Mês',
    ANUAL: 'Ano',
};
